var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00A47C",
  fillRule: "evenodd",
  d: "M6 12.002c0 3.301-2.667 6-6 6 3.333 0 6 2.667 6 6 0-3.302 2.667-6 6-6-3.302 0-6-2.667-6-6M6 0C6 3.3 3.333 6 0 6c3.333 0 6 2.698 6 6 0-3.302 2.667-6 6-6-3.302 0-6-2.667-6-6m12 0c0 3.301-2.667 6-6 6 3.302 0 6 2.698 6 6 0-3.302 2.667-6 6-6-3.302 0-6-2.667-6-6m6 6c3.333 0 6-2.699 6-6 0 3.333 2.698 6 6 6-3.333 0-6 2.698-6 6 0-3.302-2.698-6-6-6m0 12.002c3.333 0 6-2.698 6-6 0 3.333 2.698 6 6 6-3.333 0-6 2.698-6 6 0-3.333-2.698-6-6-6m-6-6c0 3.301-2.667 6-6 6 3.301 0 6 2.667 6 6 0-3.302 2.666-6 6-6-3.302 0-6-2.667-6-6",
  clipRule: "evenodd"
})));
export { SvgUnion as ReactComponent };
export default __webpack_public_path__ + "static/media/union.ba45740d.svg";